/**
 * Promo countdown banner — updates the days/hours/minutes/seconds display
 * every second client-side (the end timestamp is rendered server-side in
 * data-end, in milliseconds). Respects prefers-reduced-motion by only
 * disabling the pulse animation, never the countdown itself (it's
 * informational, not purely decorative).
 */
export function initPromoCountdown() {
	document.querySelectorAll( '[data-promo-countdown]' ).forEach( initCountdown );
}

function initCountdown( widget ) {
	if ( widget.dataset.countdownInit ) return;
	widget.dataset.countdownInit = '1';

	const endTime = Number( widget.dataset.end );
	if ( ! endTime || Number.isNaN( endTime ) ) return;

	const units = {
		days:    widget.querySelector( '[data-unit="days"] .promo-countdown__value' ),
		hours:   widget.querySelector( '[data-unit="hours"] .promo-countdown__value' ),
		minutes: widget.querySelector( '[data-unit="minutes"] .promo-countdown__value' ),
		seconds: widget.querySelector( '[data-unit="seconds"] .promo-countdown__value' ),
	};

	const pad = ( n ) => String( Math.max( 0, n ) ).padStart( 2, '0' );

	function tick() {
		const remainingMs = endTime - Date.now();

		if ( remainingMs <= 0 ) {
			if ( units.days ) units.days.textContent = '00';
			if ( units.hours ) units.hours.textContent = '00';
			if ( units.minutes ) units.minutes.textContent = '00';
			if ( units.seconds ) units.seconds.textContent = '00';
			widget.classList.add( 'is-expired' );
			window.clearInterval( interval );
			return;
		}

		const totalSeconds = Math.floor( remainingMs / 1000 );
		const days    = Math.floor( totalSeconds / 86400 );
		const hours   = Math.floor( ( totalSeconds % 86400 ) / 3600 );
		const minutes = Math.floor( ( totalSeconds % 3600 ) / 60 );
		const seconds = totalSeconds % 60;

		if ( units.days ) units.days.textContent = pad( days );
		if ( units.hours ) units.hours.textContent = pad( hours );
		if ( units.minutes ) units.minutes.textContent = pad( minutes );
		if ( units.seconds ) units.seconds.textContent = pad( seconds );
	}

	tick();
	const interval = window.setInterval( tick, 1000 );
}

